export const inputClassName = `
    bg-white
    border
    border-solid
    border-gray
    w-full
    py-2.5
    px-3
    rounded
    text-zinc-500
    disabled:opacity-75
    disabled:cursor-not-allowed
    text-base
`

export const axisInputClassName = `
    rounded-[8px]
    h-[48px]
    text-generic-neutral-900
    hover:border-generic-neutral-500
    placeholder:text-generic-neutral-700
    focus:outline
    focus:outline-[4px]
    focus:outline-generic-primary-200
    focus:outline-offset-[-4px]
    disabled:opacity-75
    disabled:cursor-not-allowed
    disabled:pointer-events-none
`

//disabled:bg-generic-neutral-100
//disabled:border-generic-neutral-200

export const timeInputContainerClassName = `
    flex
    justify-stretch
    gap-6
`

export const selectErrorClassName = `
    border-error
    bg-error-10
    focus-visible:outline-error
`

export const errorSpanClassName = `
    flex
    items-center
    text-error
    text-sm
    pt-2
`
export const textareaClassName = `
    bg-white
    border
    border-solid
    border-gray
    w-full
    py-2.5
    px-3
    rounded
    text-zinc-500
    disabled:opacity-75
    disabled:cursor-not-allowed
`
